import { Box, ButtonBase, IconButton, styled } from '@mui/material';

/** Reusable content treatments for library grids and compact resource lists. */
export const ResourceButton = styled(ButtonBase)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  gap: theme.spacing(1.5),
  height: 'calc(100% - 12px)',
  width: '100%',
  overflow: 'hidden',
  textAlign: 'left',
  borderRadius: 8,
  '&.Mui-focusVisible': {
    outline: `2px solid ${theme.palette.primary.main}`,
    outlineOffset: -2,
  },
}));

export const ResourceIcon = styled(Box)(({ theme }) => ({
  display: 'grid',
  placeItems: 'center',
  width: 38,
  height: 38,
  flexShrink: 0,
  borderRadius: 10,
  border: `1px solid ${theme.palette.studio.borders.subtle}`,
  backgroundColor:
    theme.palette.mode === 'dark'
      ? theme.palette.studio.status.syncing.bg
      : theme.palette.studio.surfaces.fillStrong,
  color:
    theme.palette.mode === 'dark'
      ? theme.palette.studio.colors.accentText
      : theme.palette.text.secondary,
  transition: theme.transitions.create(['color', 'background-color']),
}));

export const AudioPreviewSurface = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'playing',
})<{ playing: boolean }>(({ theme, playing }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  height: 38,
  padding: theme.spacing(0, 0.75),
  borderRadius: 9,
  backgroundColor: theme.palette.studio.surfaces.fillWeak,
  border: `1px solid ${playing ? theme.palette.studio.borders.accentHover : theme.palette.studio.borders.subtle}`,
  '&:hover, &:focus-within': {
    borderColor: theme.palette.studio.borders.control,
  },
}));

export const PlaybackButton = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== 'playing',
})<{ playing: boolean }>(({ theme, playing }) => ({
  padding: 4,
  width: 26,
  height: 26,
  flexShrink: 0,
  borderRadius: 6,
  color: playing
    ? theme.palette.primary.contrastText
    : theme.palette.text.primary,
  backgroundColor: playing
    ? theme.palette.primary.main
    : theme.palette.action.selected,
  '&:hover': {
    backgroundColor: playing
      ? theme.palette.primary.light
      : theme.palette.studio.surfaces.fillHeavy,
  },
  '&:focus-visible': {
    outline: `2px solid ${theme.palette.primary.main}`,
    outlineOffset: 2,
  },
  '&.Mui-disabled': {
    color: theme.palette.action.disabled,
    backgroundColor: theme.palette.action.disabledBackground,
  },
}));
